var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.1769H11V7.14613H9V5.1769ZM9 9.16923H11V15.0769H9V12.1461V9.16923ZM10 0C4 0 0 4.71877 0 10.1538C0 15.5889 4.48 20 10 20C15.52 20 20 15.5889 20 10.1538C20 4.71877 16 0 10 0ZM10 18.5C5.3125 18.5 1.5 14.8077 1.5 10.1538C1.5 5.5 5 1.5 10 1.5C15 1.5 18.5 5.40625 18.5 10.1538C18.5 14.496 14.6875 18.5 10 18.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.e978e147c1d75639d43370a1473aad38.svg";
export { ForwardRef as ReactComponent };